import Reveal from "@/components/common/Reveal";

const steps = [
  { n: "01", t: "Discovery", d: "Deep audit of brand, store, ad accounts, analytics & funnel leaks." },
  { n: "02", t: "Strategy", d: "Custom growth roadmap with revenue targets and 90-day OKRs." },
  { n: "03", t: "Design", d: "CRO-first Shopify rebuild + creative system tailored to your audience." },
  { n: "04", t: "Launch", d: "Coordinated launch across store, ads, email, and post-purchase flows." },
  { n: "05", t: "Optimize", d: "Weekly experiments, A/B tests, and performance tuning." },
  { n: "06", t: "Scale", d: "Compound growth: 2x → 5x → 10x with predictable unit economics." },
];

export default function Process() {
  return (
    <section data-testid="process-section" className="relative py-24 md:py-32 bg-[#070709] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <span className="text-xs uppercase tracking-[0.25em] text-blue-400 font-bold">The Process</span>
          <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.05]">
            Six stages, <span className="text-gradient">one outcome:</span><br /> profitable, predictable scale.
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.06}>
              <div className="relative h-full rounded-2xl bg-[#0A0A0C] border border-white/5 p-7 hover:border-blue-500/25 transition group overflow-hidden">
                <div className="font-display text-6xl font-black text-white/5 absolute -top-2 right-4 group-hover:text-blue-500/15 transition">{s.n}</div>
                <div className="text-xs uppercase tracking-[0.25em] text-blue-400 font-bold">Step {s.n}</div>
                <h3 className="mt-3 font-display text-2xl font-bold text-white">{s.t}</h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed relative z-10">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
